import { __assign, __extends } from "tslib";
import * as React from 'react';
import { Link, isHtmlLinkProps } from '../../../primitives/link/link.comp';
var BaseNavButton = /** @class */ (function (_super) {
    __extends(BaseNavButton, _super);
    function BaseNavButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseNavButton.prototype.render = function () {
        var props = this.props;
        var classNames = "nav-button deprecated-button " + props.className;
        // can't get TS to understand it's ok..
        if (isHtmlLinkProps(props)) {
            return React.createElement(Link, __assign({}, props, { className: classNames }), props.children);
        }
        else {
            return React.createElement(Link, __assign({}, props, { className: classNames }), props.children);
        }
    };
    return BaseNavButton;
}(React.PureComponent));
export { BaseNavButton };
//# sourceMappingURL=base-nav-button.comp.js.map